/**
 * Retorna a data de hoje no fuso horário do Brasil (America/Sao_Paulo)
 * no formato YYYY-MM-DD — compatível com o banco de dados.
 */
export function getHojeBR() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo' }).format(new Date());
}

/**
 * Converte qualquer Date ou string ISO para a data no fuso do Brasil (YYYY-MM-DD).
 * Útil para converter timestamps UTC do banco para o dia correto no Brasil.
 */
export function toDataBR(date) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo' }).format(new Date(date));
}
